import type { TColor } from '@Theme';
import OwnableTheme from '@Theme';
import type { FC } from 'react';
import React from 'react';
import type { StyleProp, TextStyle } from 'react-native';

import type { Size, Weight } from '../../Common/Text';
import { Text } from '../../Common/Text';

type IProductBrandProps = {
  brandName: string | null | undefined;
  weight?: Weight;
  size?: Size;
  color?: TColor;
  fontStyleOverride?: StyleProp<TextStyle>;
};

const ProductBrand: FC<IProductBrandProps> = ({
  weight = 'regular',
  size = 's',
  brandName,
  color = OwnableTheme.colors.persianIndigo,
  fontStyleOverride,
}) => {
  let renderBrand = '';

  if (brandName) {
    const trimmed = brandName.trim();
    if (trimmed.length) {
      renderBrand = trimmed;
    }
  }
  return (
    <Text
      size={size}
      weight={weight}
      gutterBottom={6}
      color={color}
      fontStyleOverride={fontStyleOverride}
    >
      {renderBrand}
    </Text>
  );
};

export default ProductBrand;
